const STATUS_MESSAGES = {
  502: 'The server is temporarily unreachable. Please try again in a moment.',
  503: 'The server is temporarily unavailable. Please try again in a moment.',
  504: 'The server took too long to respond. Please try again.',
};

// Parse an API response as JSON. Proxies and hard crashes can produce
// plain-text bodies ("Internal Server Error", "error code: 502") that make
// res.json() throw an unreadable SyntaxError; throw a friendly message instead.
export async function readJson(res) {
  const text = await res.text();
  try {
    return JSON.parse(text);
  } catch {
    throw new Error(
      STATUS_MESSAGES[res.status] || `Unexpected server response (HTTP ${res.status}). Please try again later.`
    );
  }
}
